var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:{
    login:
      _vm.$route.name == 'login' ||
      _vm.$route.name == 'nigol' ||
      _vm.$route.name == 'allbots' ||
      _vm.$route.name == 'login-low-scope'
  }},[_c('v-style',[_vm._v("\n    :root { --primary-color: "+_vm._s(_vm.$vuetify.theme.primary)+"; --bg-login:\n    "+_vm._s(_vm.$vuetify.theme.primary == '#FF706B'
        ? '#ff6868, #ffd8a4'
        : ((_vm.shadeColor(_vm.$vuetify.theme.primary, -75)) + ", " + (_vm.shadeColor(_vm.$vuetify.theme.primary, -25))))+"\n    }\n  ")]),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('loading'),_vm._v(" "),_c('v-toast',{ref:"vtoast"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1492ed04","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 